import type { Driver } from '../state/types'
import { RealtimeDriver } from './realtime'
import { ScriptDriver } from './script'

/**
 * ?demo=1 → the scripted handoff conversation (the visual acceptance
 * harness, no AI, no beacons from the flow itself); ?demo=1&auto=1 runs it
 * hands-free. Everything else gets the OpenAI Realtime bridge.
 */
export function createDriver(): Driver {
	const params = new URLSearchParams(window.location.search)
	if (params.get('demo') === '1') {
		return new ScriptDriver(params.get('auto') === '1')
	}
	return new RealtimeDriver()
}
